export default "__VITE_ASSET__BAdiedfi__"